import * as React from 'react';
import $ from 'jquery';
import { navigate } from 'mydish-ui-util';
import { useHistory } from 'react-router-dom';
import getParameterByName from '../utils/qs';
import Dropdown, { DropdownOption } from './Dropdown';
import '../css/section-toggle.sass';
import Anchor from './Anchor';

export interface SectionToggleOption {
  sectionTitle: string;
  sectionId: string;
  sendTo?: string;
  spa?: boolean;
}

interface SectionToggleProps {
  theme?: 'night' | 'day';
  maxHeight?: string;
  name: string;
  value?: string;
  label?: string;
  options: SectionToggleOption[];
  noOptionSelectedText?: string;
  id: string;
  focus?: boolean;
  onChange?: (selectedOption: SectionToggleOption) => void;
  alwaysDropdown?: boolean;
  alwaysTab?: boolean;
  history?: any;
}

interface SectionToggleState {
  value: string;
}

export default function SectionToggle(props: SectionToggleProps) {
  const [state, setState] = React.useState<SectionToggleState>({
    value:
      getParameterByName('tab') || props.value || props.options[0].sectionId
  });

  const history = useHistory();

  const onTabSelect = (selectedSectionId?: string) => {
    if (
      !!selectedSectionId &&
      props.options.some((opt) => opt.sectionId === selectedSectionId)
    ) {
      props.options.forEach((option: SectionToggleOption) => {
        if (option.sectionId === selectedSectionId) {
          $(`#${option.sectionId}`).show();
          $(`.tab-display-${option.sectionId}`).show();
          if (props.onChange !== undefined) {
            props.onChange(option);
          }
        } else {
          $(`#${option.sectionId}`).hide();
          $(`.tab-display-${option.sectionId}`).hide();
        }
      });
    }
  };

  React.useEffect(() => {
    onTabSelect(state.value);
  }, [state.value]);

  React.useEffect(() => {
    onTabSelect(props.value);
  }, [props.value]);

  const buttonsParent: any = React.useRef();

  const handleMouseDownInSectionToggle = () => {
    if (buttonsParent.current) {
      const btn = buttonsParent.current.getElementsByTagName('button');
      for (let i = 0, all = btn.length; i < all; i++) {
        btn[i].classList.add('using-mouse');
      }
    }
  };

  const handleKeyDownInSectionToggle = (e: any) => {
    if (e.keyCode === 9) {
      if (buttonsParent.current) {
        const btn = buttonsParent.current.getElementsByTagName('button');
        for (let i = 0, all = btn.length; i < all; i++) {
          btn[i].classList.remove('using-mouse');
        }
      }
    }
  };

  React.useEffect(() => {
    document.addEventListener('mousedown', handleMouseDownInSectionToggle);
    document.addEventListener('keydown', handleKeyDownInSectionToggle);
  }, [props]);

  const tabButton = (option: SectionToggleOption) => {
    if (option.sectionId === state.value)
      return (
        <span
          key={option.sectionId}
          className="active"
          id={`tabbtn${option.sectionId}`}
        >
          {option.sectionTitle}
        </span>
      );
    return (
      <button
        onMouseDown={(e: any) => {
          e.preventDefault();
        }}
        key={option.sectionId}
        role="tab"
        type="button"
        aria-selected={option.sectionId === state.value}
        aria-controls={`${option.sectionId}`}
        onClick={() => {
          setState({ value: option.sectionId });
        }}
        id={`tabbtn${option.sectionId}`}
      >
        {option.sectionTitle}
      </button>
    );
  };

  const sectionToggleRole = () => {
    if (
      props.options.length === 1 &&
      props.options[0].sectionId === state.value
    ) {
      return undefined;
    }
    if (props.options.filter((option) => option.sendTo).length > 0) {
      return 'navigation';
    }
    return 'tablist';
  };

  return (
    <>
      {(!props.alwaysDropdown || props.alwaysTab) && (
        <div className={props.alwaysTab ? 'section-tab' : 'hidden-xs'}>
          <div className="sectiontoggle">
            <div
              role={sectionToggleRole()}
              aria-label={props.label}
              ref={buttonsParent}
            >
              {props.options.map((option: SectionToggleOption) => (
                <>
                  {option.sendTo ? (
                    <Anchor
                      key={option.sectionId}
                      id={`linkBtn${option.sectionId}`}
                      arialabel={option.sectionTitle}
                      href={option.sendTo}
                      target="_self"
                      theme={props.theme}
                      aria-current="page"
                      spa={option.spa}
                      history={option.spa ? history : undefined}
                    >
                      {option.sectionTitle}
                    </Anchor>
                  ) : (
                    <>{tabButton(option)}</>
                  )}
                </>
              ))}
            </div>
          </div>
        </div>
      )}
      {!props.alwaysTab && (
        <div className={props.alwaysDropdown ? '' : 'hidden-lg'}>
          <Dropdown
            label={props.label || ''}
            name={props.name}
            id={props.id}
            maxHeight={props.maxHeight}
            options={props.options.map((option: SectionToggleOption) => {
              return { value: option.sectionId, text: option.sectionTitle };
            })}
            value={state.value}
            theme={props.theme}
            noOptionSelectedText={props.noOptionSelectedText}
            focus={props.focus}
            onChange={(selectedOption: DropdownOption) => {
              setState({ value: selectedOption.value });
              props.options.forEach((option: SectionToggleOption) => {
                if (
                  option.sectionId === selectedOption.value &&
                  option.sendTo
                ) {
                  navigate(option.sendTo, history);
                }
              });
            }}
          />
        </div>
      )}
    </>
  );
}
